enum NotificationType {
    Success,
    Error
}

export default NotificationType;
